// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"SelectedQuestionGroupIcon_buttonContainer__1MPkd"};